module.exports = __webpack_public_path__ + "img/4_129.a8f3bddf.png";